export default class ValidationUtils {
  static validateRedirectPath(redirect = '') {
    // Checks to ensure returnTo is a path and not another URL (i.e. "https://..." or "//www.stride...")
    const isUrlPath = redirect.match('^/(?!/)');
    // Safe to decode the returnTo so we can also decode potential query params on the returnTo that also have a script being injected
    // eslint-disable-next-line no-script-url
    const directlyContainsJavascript = decodeURIComponent(redirect).includes('javascript:');
    return isUrlPath && !directlyContainsJavascript;
  }
}
